import React from "react";
import styles from './icons.module.css';

const ArrowIcon = ({ direction = "up", size = 24, ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={`${styles.arrowIcon} ${direction === "down" ? styles.arrowIconDown : styles.arrowIconUp}`}
      {...props}
    >
      <path
        d="M10.5491 6.44413L3.21226 14.2975C2.52642 15.0317 1.35883 15.0858 0.604291 14.4184C-0.150251 13.7511 -0.205876 12.615 0.479965 11.8808L11.0291 0.589281C11.7616 -0.195053 13.029 -0.195053 13.7615 0.589281L24.3106 11.8808C24.9964 12.615 24.9408 13.7511 24.1863 14.4184C23.4317 15.0858 22.2646 15.0317 21.5783 14.2975L14.2414 6.44413L14.2414 21.8146C14.2414 22.8067 13.4149 23.6113 12.3953 23.6113C11.3758 23.6113 10.5488 22.8067 10.5488 21.8146L10.5491 6.44413Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ArrowIcon;
